/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { Input, Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";

import { Workflow } from "../models/workflow";
import { WorkflowService } from "../services/workflow.service";

@Injectable()
//@Input() KHT - using the @Input() tag breaks certain resolvers after Angular 12 update
export class WorkflowResolver implements Resolve<Workflow> {

    constructor(
        private workflowService: WorkflowService
    ) {}

    async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<Workflow> {
        const id = route.paramMap.get('id');
        console.log("Resolving Workflow ID: " + id);
        
        if (id == null || id.length == 0) {
            return null;
        }
        else {
            let workflow: Workflow;
            
            try {
                workflow = await this.workflowService.getAllWorkflowById(Number.parseInt(id, 10));
            }
            catch (error) {
                console.error("Problem resolving workflow: " + error, error);
            }
            
            return workflow;
        }
    }
}
